/**
 * @author hxliu 2020-04-13
 * 考试查看
 */
import React from 'react'
import { connect } from 'dva'
import moment from "moment";
import { modelUtils } from '../../../../utils'
import { component_tool, framework_tool, utils_tool } from '../../../../tool'
// import { WizAuthority } from '@/containers/common'
import { AudienceGroupItem } from '@/components';

import {
    ChapterLook,
} from '@/containers/online';
let {
    WizSpin,
    WizCard,
    WizRow,
    WizCol,
    WizSurveyAudience,
    WizTabs,
    WizCollapse,
    WizButton,
    WizSearchBar,
    WizDataTable,
    WizModalForm,
    WizAlert
} = component_tool
import { Spin } from 'antd'
let { WizContainer } = framework_tool
let { Session, getPageData } = utils_tool


const getParamRecord = (history) => {
    let record = {}
    if (history.location) {
        if (history.location.pathname === '/online/exam/examLook'
            || history.location.pathname === '/interact/activity/activityDetailToPart/activityPartLook/toExam'
            || history.location.pathname === '/featured/management/featuredLook/featuredExam') {
            if (history.location.record) {
                record = history.location.record
                Session.set('examDetailInfo', record)
            } else {
                record = Session.get('examDetailInfo') || {}
            }
        }
    }
    return record
}
class ExamLook extends WizContainer {
    componentName = 'examLook'

    constructor(props) {
        super(props)
        let record = getParamRecord(props.history)
        this.state = {
            record: record,
            chapterRecord: {},
            targetScopeRecord: { orgIds: [], positionIds: [], positionCategoryIds: [], personIds: [] },
            data: [],
            message: [],
        }
        this._examId = record['id']
    }

    //题目类型对应
    _getValue(type, key) {
        const values = {
            type: {
                0: '单选题',
                1: '多选题',
                2: '判断题',
                3: '填空题',
                4: '主观题'
            },
            difficulty: {
                0: '低',
                1: '中',
                2: '高',
            },
            chapter: {
                0: '综合',
                1: '固定',
                2: '随机',
            }
        }
        return values[type][key]
    }
    propsAndStateOnChange = {
        chapterInfo: this._chapterInfo.bind(this),
        targetScopeInfo: this._targetScopeInfo.bind(this),
        examInfo: this._examInfoOver.bind(this)
    }


    _targetScopeInfo(nextProps, nextState) {
        let { targetScopeInfo } = nextProps
        if (targetScopeInfo && targetScopeInfo['success']) {
            let data = Object.assign({}, targetScopeInfo['data'])
            if (data['orgIds'] && data['orgIds'] instanceof Array) {
                data['orgIds'] = data['orgIds'].reduce((acc, cur, index) => {
                    for (let i = 0; i < acc.length; i++) {
                        const element = acc[i];
                        if (element['categoryId'] === cur['categoryId']) {
                            acc[i]['name'] = acc[i]['name'] + ',' + cur['name']
                            return acc;
                        }
                    }
                    return acc.concat({ id: cur['id'], name: cur['categoryName'] + ':' + cur['name'], categoryId: cur['categoryId'] })
                }, []);
            }
            data['message'] = [`受众人数：${data['scopeCount'] || 0}`, `已考人数：${data['successCount'] || 0}`]
            this.setState({
                targetScopeRecord: data,
            });
        } else {
            wizNotice.error(targetScopeInfo && targetScopeInfo['msg'] || '操作失败,请稍后尝试')
        }
        return false
    }
    _chapterInfo(nextProps, nextState) {
        let chapterInfo = nextProps['chapterInfo'];
        if (chapterInfo && chapterInfo['success']) {
            let data = []
            if (chapterInfo['data'] && chapterInfo['data'] instanceof Array) {
                chapterInfo['data'].forEach((value, index) => {
                    value['order'] = value['id']
                    value['badge'] = this._getValue('chapter', value['type'])
                    value['title'] = value['title']
                    value['score'] = value['score']
                    value['order'] = index
                    if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
                        value['questionTabelForm'].forEach((tabel, key) => {
                            tabel['typeChar'] = this._getValue('type', tabel['type'])
                            tabel['order'] = key
                        })
                    }
                    if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
                        value['categoryTabelForm'].forEach((categoryTabel, key) => {
                            let categoryIds = categoryTabel['categoryIds']
                            let categoryNames = categoryTabel['categoryNames']
                            let ownCactegoryInfo = [{ key: categoryIds, title: categoryNames, label: categoryNames, value: categoryIds }]
                            categoryTabel['questionCategory'] = ownCactegoryInfo
                            categoryTabel['questionCategoryTitle'] = categoryNames
                            categoryTabel['difficultyTitle'] = this._getValue('difficulty', categoryTabel['difficulty'])
                            categoryTabel['typeTitle'] = this._getValue('type', categoryTabel['type'])
                            categoryTabel['order'] = key

                        })
                    }
                })
            }

            this.setState({
                data: chapterInfo['data'],
            });

        }
        return false;
    }

    _examInfoOver(nextProps, nextState) {
        let { examInfo } = nextProps
        if (examInfo && examInfo['success']) {
            nextState.record = examInfo.data
            return true
        } else {
            wizNotice.error(targetScopeInfo && targetScopeInfo['msg'] || '操作失败,请稍后尝试')
            return false
        }
    }

    _componentDidMount = () => {
        const { record } = this.state

        this.doActions([
            {
                path: 'exam/chapterInfo',
                payload: {
                    key: 'chapterInfoKey',
                    apiParams: {
                        id: record['id']
                    }
                }
            }, {
                path: 'exam/targetScopeInfo',
                payload: {
                    key: 'targetScopeInfoKey',
                    apiParams: {
                        id: record['id']
                    }
                }
            },
            {
                path: 'exam/getExamById',
                payload: {
                    key: 'examInfo',
                    apiParams: {
                        id: record['id']
                    }
                }
            }
        ]);
        const arr = [];
        this.setState({
            data: arr
        });
    }



    _booleanConvert(key) {
        return key ? '是' : '否'
    }
    _timeConvret(time) {
        if (time != null && time != undefined) {
            return moment(time).format("YYYY-MM-DD HH:mm")
        } else {
            return ''
        }
    }



    _renderContentRow(ln, lv = '', rn, rv = '') {
        return (
            <WizRow className='administrationScope-row-item'>
                <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
                <WizCol span={6}>{lv}</WizCol>
                <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
                <WizCol span={9}>{rv}</WizCol>
            </WizRow>
        )
    }


    _render() {
        const { record, data, chapterRecord, targetScopeRecord, message } = this.state
        let { examLoading } = this.props
        let status = '';
        let examType = '';
        if (record['status'] === 0) { status = '草稿' }
        if (record['status'] === 1) { status = '已发布' }
        if (record['status'] === 2) { status = '已关闭' }
        if(record['examType']===0){examType = '独立考试'}
        if(record['examType']===1){examType = '课程考试'}
        return (
            <>
                <WizCard  >
                    <WizCollapse className='administrationScope-collapse'
                        expandIconPosition='right'
                        defaultActiveKey={[
                            0
                        ]}
                    >
                        <WizCollapse.Panel key={0} header={'考试信息'} className='panel-item'>
                            {this._renderContentRow('考试名称', record['title'],'考试类型',examType)}
                            {this._renderContentRow( '状态', status,'考试分类', record['categoryType'])}
                            {this._renderContentRow('考试时间', `${this._timeConvret(record['startDate'])}~${this._timeConvret(record['endDate'])}`, '考试时长', `${record['limitMinutes'] || 0}分钟`)}
                            {this._renderContentRow('总分/通过分数', `${record['totalScore'] || 0}/${record['passScore'] || 0}`, '允许重复考试', `${record['count'] || 0}次`)}
                            {this._renderContentRow('试卷题序打乱', this._booleanConvert(record['shuffle']), '身份验证', this._booleanConvert(record['face']))}
                        </WizCollapse.Panel>
                        <WizCollapse.Panel key={1} header={'考试受众'} className='panel-item'>
                            <Spin tip={'加载中'} spinning={examLoading}>
                                {/* <WizSurveyAudience data={targetScopeRecord} labelWidth={4} /> */}
                                {/* <WizAuthority value={targetScopeRecord} mode="Show" />  */}
                                <AudienceGroupItem {...targetScopeRecord} showMessage={true} />
                            </Spin>
                        </WizCollapse.Panel>
                        <WizCollapse.Panel key={2} header={'考试章节'} className='panel-item'>
                            <ChapterLook data={data} record={chapterRecord} examLoading={examLoading} />
                        </WizCollapse.Panel>
                    </WizCollapse>
                </WizCard>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { exam } = state;
    const examInfo = modelUtils.getModelEntity(exam, 'examInfo');
    const chapterInfo = modelUtils.getModelEntity(exam, "chapterInfoKey");
    const targetScopeInfo = modelUtils.getModelEntity(exam, "targetScopeInfoKey");
    const load = modelUtils.getLoadingState(state, ['exam']);
    return {
        examInfo,
        chapterInfo,
        targetScopeInfo,
        ...load
    }
}

export default connect(mapStateToProps)(ExamLook)
